import React, { useRef } from "react";
import FontAwesome from "react-fontawesome";
import { useTranslation } from "react-i18next";

const SearchBox = ({
  value = "",
  onChange,
  className = "",
  inputClassName = "",
  placeholder,
  ...rest
}) => {
  const { t } = useTranslation();
  const inputRef = useRef(null);
  const hasValue = String(value ?? "").length > 0;

  const handleClear = () => {
    onChange("");
    inputRef.current?.focus();
  };

  return (
    <div
      className={["search-box-field", hasValue ? "has-value" : "", className]
        .filter(Boolean)
        .join(" ")}
    >
      <span className="search-box-icon" aria-hidden="true">
        <FontAwesome name="search" />
      </span>
      <input
        ref={inputRef}
        type="text"
        name="query"
        className={["form-control", "search-box", inputClassName]
          .filter(Boolean)
          .join(" ")}
        placeholder={placeholder || t("SearchPrompt")}
        value={value}
        onChange={(e) => onChange(e.currentTarget.value)}
        {...rest}
      />
      {hasValue && (
        <button
          type="button"
          className="search-box-clear is-visible"
          onClick={handleClear}
          aria-label={t("ClearSearch", { defaultValue: "Clear search" })}
          title={t("ClearSearch", { defaultValue: "Clear search" })}
        >
          <FontAwesome name="times" />
        </button>
      )}
    </div>
  );
};

export default SearchBox;
